$.initialisePrimaryNav = () => {
  document.addEventListener("DOMContentLoaded", function() {
  let primaryNavBar = document.querySelectorAll('.primary-nav');
  if(primaryNavBar.length) {
      document.activeElement.blur();
      //adjust height of mobile menu when url bar resizes
      function calcVH() {
        if(window.innerWidth < 1024) {
          var vH = Math.max( window.innerHeight || 0);
          var primaryMenu = document.querySelector(".primary-menu");
          if (primaryMenu) {
            primaryMenu.setAttribute("style", "max-height:" + (vH - 150) + "px;");
          }
        }
      }

      calcVH();
      window.addEventListener('onorientationchange', calcVH, true);
      $(window).smartresize(() => {
        calcVH();
      })

      //length of search bar
      function resizeSearchBar() {
        const navBarLength = primaryNavBar[0].offsetWidth;
        const navBarLengthFinal = navBarLength - 60 ;
        const searchBar = document.querySelector('.dropdown__container--search .dropdown');
        searchBar.style.width = navBarLengthFinal + "px";
      }

      setTimeout(() => {
        resizeSearchBar();
      }, 2000);
      
      $(window).smartresize(() => {
        resizeSearchBar();
      })

      // desktop menu
      const menuItems = document.querySelectorAll('li.has-submenu');
      let timer = null;
      const hideSubmenus = () => {
        const openSubmenu = document.querySelector('.has-submenu.open');
        if (openSubmenu) {
          openSubmenu.className = 'has-submenu';
        }
      };
      const menuItemLinks = document.querySelectorAll('li.has-submenu > a');
      const dropdownMenuItemLinks = document.querySelectorAll('li.has-submenu > ul > li > a');

      function findAncestor (el, cls) {
        while ((el = el.parentElement) && !el.classList.contains(cls));
        return el;
      }

    //accessibility for first level navigation
    if(menuItemLinks.length) {
      Array.prototype.forEach.call(menuItemLinks, (el) => {

        let parent = el.parentElement;
        el.addEventListener('focus', function(event) {
          hideSubmenus();
          parent.className = 'has-submenu open';
          clearTimeout(timer);
        });

        el.addEventListener('touchend', function(event) {
          if(window.innerWidth >= 1024) {
            let allActivePrimaryNav = document.querySelectorAll('.touch-active');

            if(!el.classList.contains('touch-active')) {
              event.preventDefault();
              hideSubmenus();
              const parentNav = findAncestor(el, 'has-submenu');
              parentNav.className = 'has-submenu open';
              clearTimeout(timer);
            }
            Array.prototype.forEach.call(allActivePrimaryNav, (el) => {
              el.classList.remove('touch-active')
            })

            el.classList.toggle('touch-active');
          }
        });

        el.addEventListener('keydown', function(event) {
            let key = event.keyCode;
            if (key === 40) {
              event.preventDefault();
              let firstMenuItem = parent.querySelectorAll('ul li')[0].querySelector('a');
              firstMenuItem.focus();
            } else if (key === 9 && !event.shiftKey) {
              let nextNavItem = findAncestor(el, 'has-submenu');
              if(nextNavItem.nextElementSibling !== null) {
                event.preventDefault();
                hideSubmenus();
                nextNavItem.nextElementSibling.querySelector('a').focus();
              } else {
                const btn = document.querySelector('.js-search .btn--search');
                if(btn) {
                  event.preventDefault();
                  btn.focus();
                }
                hideSubmenus();
              }
            } else if(event.shiftKey && event.keyCode == 9) {
              hideSubmenus();
              let prevNavItem = findAncestor(el, 'has-submenu').previousElementSibling;
              if(prevNavItem) {
                event.preventDefault();
                prevNavItem.querySelector('a').focus();

              }
            }

        });
      });
    }

    if(dropdownMenuItemLinks.length) {
      //accessibility using up/down arrows for menu items
      Array.prototype.forEach.call(dropdownMenuItemLinks, (el) => {
        el.addEventListener('keydown', function(event) {
          event.preventDefault();
            let key = event.keyCode;
            let parent = el.parentElement;
            let nextMenuItemLink = parent.nextElementSibling;
            let prevMenuItemLink = parent.previousElementSibling;
            if (key === 40 && nextMenuItemLink ) {
              nextMenuItemLink.querySelector('a').focus();
            } else if (key === 38 && prevMenuItemLink) {
              prevMenuItemLink.querySelector('a').focus();
            } else if (key === 9 && !event.shiftKey) {
              let nextNavItem = findAncestor(parent, 'has-submenu');
              hideSubmenus();
              if(nextNavItem.nextElementSibling !== null) {
                nextNavItem.nextElementSibling.querySelector('a').focus();
              }
            } else if(event.shiftKey && event.keyCode == 9) {
              hideSubmenus();
              let prevNavItem = findAncestor(parent, 'has-submenu');
              prevNavItem.previousElementSibling.querySelector('a').focus();
            }

        });
      });
    }

    if(menuItems.length) {
      Array.prototype.forEach.call(menuItems, (el) => {
        const dropdownOpen = document.querySelector('.dropdown__container--search.open') === null;
        el.addEventListener('mouseover', function () {
          if(dropdownOpen) {
            hideSubmenus();
            this.className = 'has-submenu open';
            clearTimeout(timer);
          }
        });
        // set up mobile nav click event to move to level 2 items
        const level2ToggleEl = el.querySelector('.mobile-sub-toggle');
        level2ToggleEl.addEventListener('click', function (e) {
          const bodyEl = document.querySelector('body');
          const isMobile = bodyEl.className === 'body-container primary-nav-open';
          if (isMobile) {
            e.preventDefault();
            $(level2ToggleEl).toggleClass('open');
          }
          hideSubmenus();
          const parentList = $(el).closest('li');
          parentList.className = 'has-submenu open';
          parentList.find('ul').toggle('open');
          clearTimeout(timer);
        });

        el.addEventListener('mouseout', () => {
          timer = setTimeout(hideSubmenus, 500);
        });
        const btn = '<button><span><span class="visually-hidden">show submenu</span></span></button>';
        const topLevelLink = el.querySelector('a');
        topLevelLink.innerHTML = `${topLevelLink.innerHTML} ${btn}`;
        el.querySelector('a button').addEventListener('click', function (e) {
          e.preventDefault();
          if (this.parentNode.parentNode.className === 'has-submenu') {
            hideSubmenus();
            this.parentNode.parentNode.className = 'has-submenu open';
            this.parentNode.setAttribute('aria-expanded', 'true');
            this.querySelector('.visually-hidden').innerText = 'hide submenu';
          } else {
            this.parentNode.parentNode.className = 'has-submenu';
            this.parentNode.setAttribute('aria-expanded', 'false');
            this.querySelector('.visually-hidden').innerText = 'show submenu';
          }
        });
      });
    }


    // mobile menu
    const menuToggleEl = document.querySelector('#js-menu-toggle');
    if (menuToggleEl) {
      menuToggleEl.addEventListener('click', () => {
        const bodyEl = document.querySelector('body');
        bodyEl.classList.toggle('primary-nav-open');
      });
    }

    //hide search bar if not included
    let primaryNav = document.querySelector(".primary-nav");
    if( !document.querySelectorAll(".primary-nav .mobile-btn").length && primaryNav) {
      primaryNav.classList.add('no-search')
    }
  }

})
};



$.initialisePrimaryNav();
